export default __webpack_public_path__ + "static/media/walking.12b42597.png";